export const paperclip = () => (
  <path
    d="M21.44 11.05l-9.19 9.19a6.003 6.003 0 11-8.49-8.49l9.19-9.19a4.002 4.002 0 015.66 5.66l-9.2 9.19a2.001 2.001 0 11-2.83-2.83l8.49-8.48"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
